import React, { useState } from "react";

import plus1 from "../../../assets/icons/plus1.svg";
import close from "../../../assets/icons/close.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../Components/LoaderAndSpinner/Loader";
import { useDispatch } from "react-redux";
import { fetchMenuItems } from "../../../Redux/Menu/MenuSlice";
import fetchWrapper from "../../../AuthMiddleware/FetchWrapper";
// import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
const AddModal = ({ show, handleClose, onAdd, parameters }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  // const validateOrder = (value) => /^\d+$/.test(value) && Number(value) >= 1;
  const [formData, setFormData] = useState({
    masterData: {
      master_name: "",
      slug: null,
      display_name_singular: "",
      display_name_plural: "",
      icon: null,
      model_name: "",
      parameter_type_id: "",
      order: "",
    },
    masterFieldData: [
      {
        field_name: "",
        field_type: "",
        display_name: "",
        required: "",
        default: false,
        is_unique: false,
        order: 1,
        browse: false,
        read: false,
        edit: false,
        add: false,
        delete: false,
        validation: "",
        tooltip: "",
      },
    ],
  });
  const [err1, setErr1] = useState("");
  // const [fieldErrors, setFieldErrors] = useState([]);
  const [isFieldNameValid, setIsFieldNameValid] = useState(true);
  const [errors, setErrors] = useState({});

  const validateFieldName = (value) => /^[a-z_]*$/.test(value);
  const stringToSlug = (str) => {
    return str
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "") // Remove special characters
      .replace(/\s+/g, "_") // Replace spaces with underscores
      .replace(/_+/g, "_"); // Replace multiple underscores with a single underscore
  };


const handleChange = (e, index = null, section = null) => {
  e.preventDefault();
  const { name, value } = e.target;

  // Prevent negative values
  const numericValue = Number(value);
  if (numericValue < 0) {
    return;
  }

  if (section === "masterData") {
    let updatedMasterData = { ...formData.masterData, [name]: value };

    // Convert master_name to slug and set it as model_name
    if (name === "master_name") {
      updatedMasterData.model_name = stringToSlug(value);
    }

    // Update formData with the new masterData
    setFormData((prevFormData) => ({
      ...prevFormData,
      masterData: updatedMasterData,
    }));

    // If the parameter_type_id changes, update the order field automatically
    if (name === "parameter_type_id") {
      const selectedParameter = parameters.find(
        (param) => param._id === value
      );
      const newOrder = selectedParameter
        ? selectedParameter.masterCount + 1
        : "";

      setFormData((prevFormData) => ({
        ...prevFormData,
        masterData: {
          ...updatedMasterData,
          order: newOrder,
        },
      }));
    }
  } else if (section === "masterFieldData") {
    setFormData((prevFormData) => {
      let updatedFields = [...prevFormData.masterFieldData];

      updatedFields[index] = {
        ...updatedFields[index],
        [name]: value,
      };

      // Convert display_name to slug and set it as field_name
      if (name === "display_name") {
        updatedFields[index].field_name = stringToSlug(value);
      }

      // Handle default = true
      if (name === "default") {
        if (value === "true") {
          updatedFields[index].required = "true";
          updatedFields[index].is_unique = "true";
        } else if (value === "false") {
          updatedFields[index].is_unique = "false";
          // Keep required editable unless Is Unique = true
          if (updatedFields[index].is_unique !== "true") {
            updatedFields[index].required = updatedFields[index].required; 
          }
        }
      }

      // Handle is_unique = true → automatically set required = true (if default !== true)
      if (name === "is_unique" && value === "true") {
        if (updatedFields[index].default !== "true") {
          updatedFields[index].required = "true";
        }
      }

      return {
        ...prevFormData,
        masterFieldData: updatedFields,
      };
    });

    if (name === "field_name") {
      const isValid = validateFieldName(value);
      setIsFieldNameValid(isValid);
    }
  }
};


  const handleAddField = (e) => {
    e.preventDefault();
    setFormData((prevFormData) => ({
      ...prevFormData,
      masterFieldData: [
        ...prevFormData.masterFieldData,
        {
          field_name: "",
          field_type: "",
          display_name: "",
          required: "",
          default: false,
          is_unique: false,
          order: prevFormData.masterFieldData.length + 1, // Increment order
          browse: false,
          read: false,
          edit: false,
          add: false,
          delete: false,
          validation: "",
          tooltip: "",
        },
      ],
    }));
  };

  const handleRemoveField = (index) => {
    setFormData((prevFormData) => {
      const updatedFields = prevFormData.masterFieldData.filter(
        (field, idx) => idx !== index
      );
      return {
        ...prevFormData,
        masterFieldData: updatedFields,
      };
    });
    // setFieldErrors((prevErrors) =>
    //   prevErrors.filter((_, idx) => idx !== index)
    // );
  };

  const handleAdd = async (e) => {
    setLoading(true);
    e.preventDefault();



    const defaultTrueCount = formData.masterFieldData.filter(
      (field) => field.default === "true"
    ).length;

    if (defaultTrueCount !== 1) {
      setLoading(false);
      toast.error("Atmost only one field can be set as default.");
      setErr1("Only one field can be set as default.");
      return;
    }

    const uniqueFields = formData.masterFieldData.filter(
      (field) => field.is_unique === "true"
    );

    const displayNameCounts = {};
    for (const field of uniqueFields) {
      const name = field.display_name?.trim().toLowerCase();
      if (!name) continue;
      displayNameCounts[name] = (displayNameCounts[name] || 0) + 1;
    }

    const duplicates = Object.keys(displayNameCounts).filter(
      (key) => displayNameCounts[key] > 1
    );

    if (duplicates.length > 0) {
      setLoading(false);
      toast.error("Duplicate display name found for unique fields.");
      setErr1("Duplicate display name not allowed for unique fields.");
      return;
    }

    const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/add-master-and-fields`;

    try {
      // const response =
      await fetchWrapper(
        apiUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        },
        navigate()
      );

      setLoading(false);

      // const data = response; // No need to call response.json() as fetchWrapper already does that


      // Clear the form fields
      setFormData({
        masterData: {
          master_name: "",
          slug: null,
          display_name_singular: "",
          display_name_plural: "",
          icon: null,
          model_name: "",
          parameter_type_id: "",
          order: "",
        },
        masterFieldData: [
          {
            field_name: "",
            field_type: "",
            display_name: "",
            required: "",
            default: "",
            is_unique: "",
            // order: "",
            browse: false,
            read: false,
            edit: false,
            add: false,
            delete: false,
            order: 0,
            validation: "",
            tooltip: "",
          },
        ],
      });

      onAdd();
      dispatch(fetchMenuItems());
      toast.success("Master added successfully");
    } catch (error) {
      setLoading(false);
      console.error("Error adding master:", error);
      toast.error(error.response?.message || "Failed to create master");
      setErrors(error.response?.errors || {});
      console.error("Error adding master:", error.response?.errors);
    }
  };

  return (
    <div
      id="overlay"
      className={`modal fade ${show ? "show" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{
        zIndex: 30,
        display: show ? "block" : "none",
        transition: "width 2s",
      }}
    >
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="addunit-card Width 25%  ">
            <form
              onSubmit={handleAdd}
              noValidate
              className="needs-validation"
              autoComplete="off"
            >
              <div className="addunit-header">
                <h4>Add Master</h4>
                <button
                  style={{ border: "none", backgroundColor: "inherit" }}
                  type="button"
                  className="close"
                  onClick={() => {
                    setFormData({
                      masterData: {
                        master_name: "",
                        slug: null,
                        display_name_singular: "",
                        display_name_plural: "",
                        icon: null,
                        model_name: "",
                        parameter_type_id: "",
                        order: "",
                      },
                      masterFieldData: [
                        {
                          field_name: "",
                          field_type: "",
                          display_name: "",
                          required: "",
                          default: "",
                          is_unique: "",
                          order: "",
                          browse: false,
                          read: false,
                          edit: false,
                          add: false,
                          delete: false,
                          order: 0,
                          validation: "",
                          tooltip: "",
                        },
                      ],
                    });
                    setErrors({});
                    handleClose();
                  }}
                >
                  <img src={close} width="28px" height="28px" alt="Close" />
                </button>
              </div>
              <div
                className="addunit-form"
                style={{ maxHeight: "70vh", overflowY: "auto" }}
              >
                <div className="" style={{ marginBottom: "-25px" }}>
                  <div className="row ">
                    <div className="col">
                      <div className="d-flex flex-column">
                        <label htmlFor="name" className="addunit-form-text">
                          Master Name <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="master_name"
                          value={formData.masterData.master_name}
                          onChange={(e) => handleChange(e, null, "masterData")}
                          placeholder="Enter The Master Name"
                          className={`form-control ${errors[`masterData.master_name`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`masterData.master_name`] && (
                          <div className="invalid-feedback">
                            {errors[`masterData.master_name`]}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="d-flex flex-column mb-4">
                        <label
                          htmlFor="model_name"
                          className="addunit-form-text"
                        >
                          Table Name <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="model_name"
                          placeholder="Enter The Table Name"
                          value={formData.masterData.model_name}
                          onChange={(e) => handleChange(e, null, "masterData")}
                          className={`form-control ${errors[`masterData.model_name`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`masterData.model_name`] && (
                          <div className="invalid-feedback">
                            {errors[`masterData.model_name`]}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row mb-4">
                    <div className="col">
                      <div className="d-flex flex-column">
                        <label
                          htmlFor="display_name_singular"
                          className="addunit-form-text"
                        >
                          Display Name Singular{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter The Singular Name"
                          name="display_name_singular"
                          value={formData.masterData.display_name_singular}
                          onChange={(e) => handleChange(e, null, "masterData")}
                          className={`form-control ${errors[`masterData.display_name_singular`]
                            ? "is-invalid"
                            : ""
                            }`}
                        />
                        {errors[`masterData.display_name_singular`] && (
                          <div className="invalid-feedback">
                            {errors[`masterData.display_name_singular`]}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col">
                      <div className="d-flex flex-column">
                        <label
                          htmlFor="display_name_plural"
                          className="addunit-form-text"
                        >
                          Display Name Plural{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter The Plural Name"
                          name="display_name_plural"
                          value={formData.masterData.display_name_plural}
                          onChange={(e) => handleChange(e, null, "masterData")}
                          className={`form-control ${errors[`masterData.display_name_plural`]
                            ? "is-invalid"
                            : ""
                            }`}
                        />
                        {errors[`masterData.display_name_plural`] && (
                          <div className="invalid-feedback">
                            {errors[`masterData.display_name_plural`]}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row mb-4">
                    <div className="col-6">
                      <div className="d-flex flex-column mb-4">
                        <label
                          htmlFor="parameter_type_id"
                          className="addunit-form-text"
                        >
                          Parameter Type <span className="text-danger"> *</span>
                        </label>
                        <select
                          className={`form-select select-unit textarea ${errors[`masterData.parameter_type_id`]
                            ? "is-invalid"
                            : ""
                            }`}
                          id="1"
                          name="parameter_type_id"
                          value={formData.masterData.parameter_type_id}
                          onChange={(e) => handleChange(e, null, "masterData")}
                        >
                          <option value="">Select Parameter</option>
                          {parameters.map((parameter) => (
                            <option key={parameter._id} value={parameter._id}>
                              {parameter.parameter_type_name}
                            </option>
                          ))}
                        </select>
                        {errors[`masterData.parameter_type_id`] && (
                          <div className="invalid-feedback">
                            {errors[`masterData.parameter_type_id`]}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="d-flex flex-column">
                        <label htmlFor="order" className="addunit-form-text">
                          Order <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="number"
                          name="order"
                          value={formData.masterData.order}
                          onChange={(e) => handleChange(e, null, "masterData")}
                          placeholder="Enter Order"
                          className={`form-control ${errors[`masterData.order`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`masterData.order`] && (
                          <div className="invalid-feedback">
                            {errors[`masterData.order`]}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <hr />
                <h5 className="mb-3">Master Fields </h5>

                {formData.masterFieldData.map((field, index) => (
                  <div className="" key={index}>
                    {formData.masterFieldData.length > 1 && (
                      <div className="row">
                        <div className="d-flex justify-content-end col-md-12">
                          <button
                            style={{
                              border: "none",
                              backgroundColor: "inherit",
                            }}
                            type="button"
                            className="close"
                            onClick={() => handleRemoveField(index)}
                          >
                            <img
                              src={close}
                              width="28px"
                              height="28px"
                              alt="Close"
                            />
                          </button>
                        </div>
                      </div>
                    )}
                    <div className="row mb-4">
                      <div className="col">
                        <div className="d-flex flex-column">
                          <label
                            htmlFor="field_type"
                            className="addunit-form-text"
                          >
                            Field Type <span className="text-danger"> *</span>
                          </label>
                          <select
                            name="field_type"
                            value={field.field_type}
                            onChange={(e) =>
                              handleChange(e, index, "masterFieldData")
                            }
                            className={`form-select select-unit textarea ${errors[`masterFieldData[${index}].field_type`]
                              ? "is-invalid"
                              : ""
                              }`}
                          >
                            <option value="" disabled>
                              Select Field Type
                            </option>
                            <option value="String">String</option>
                            <option value="Number">Number</option>
                            <option value="Date">Date</option>
                          </select>
                          {errors[`masterFieldData[${index}].field_type`] && (
                            <div className="invalid-feedback">
                              {errors[`masterFieldData[${index}].field_type`]}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col">
                        <div className="d-flex flex-column">
                          <label
                            htmlFor="display_name"
                            className="addunit-form-text"
                          >
                            Display Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="display_name"
                            placeholder="Enter The Display Name"
                            value={field.display_name}
                            onChange={(e) =>
                              handleChange(e, index, "masterFieldData")
                            }
                            className={`form-control ${errors[`masterFieldData[${index}].display_name`]
                              ? "is-invalid"
                              : ""
                              }`}
                          />
                          {errors[`masterFieldData[${index}].display_name`] && (
                            <div className="invalid-feedback">
                              {errors[`masterFieldData[${index}].display_name`]}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row mb-4">
                      <div className="col">
                        <div className="d-flex flex-column">
                          <label
                            htmlFor="field_name"
                            className="addunit-form-text"
                          >
                            Field Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="field_name"
                            placeholder="Enter The Field Name"
                            id={`fieldName${index}`}
                            value={field.field_name}
                            onChange={(e) =>
                              handleChange(e, index, "masterFieldData")
                            }
                            className={`form-control ${errors[`masterFieldData[${index}].field_name`]
                              ? "is-invalid"
                              : ""
                              }`}
                          />
                          {errors[`masterFieldData[${index}].field_name`] && (
                            <div className="invalid-feedback">
                              {errors[`masterFieldData[${index}].field_name`]}
                            </div>
                          )}
                          {!validateFieldName(field.field_name) && (
                            <span className="text-danger">
                              Invalid characters. Use lowercase letters and
                              underscores only.
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col">
                        <div className="d-flex flex-column">
                          <label htmlFor="order" className="addunit-form-text">
                            Order <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="number"
                            name="order"
                            placeholder="Set the order"
                            value={field.order}
                            onChange={(e) =>
                              handleChange(e, index, "masterFieldData")
                            }
                            className={`form-control ${errors[`masterFieldData[${index}].order`]
                              ? "is-invalid"
                              : ""
                              }`}
                          />
                          {errors[`masterFieldData[${index}].order`] && (
                            <div className="invalid-feedback">
                              {errors[`masterFieldData[${index}].order`]}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-4">
                      <div className="col col-6">
                        <div className="d-flex flex-column">
                          <label
                            htmlFor="default"
                            className="addunit-form-text"
                          >
                            Is Default <span className="text-danger"> *</span>
                          </label>
                          <select
                            name="default"
                            value={field.default}
                            onChange={(e) =>
                              handleChange(e, index, "masterFieldData")
                            }
                            className={`form-select select-unit textarea ${errors.masterFields?.[index]?.errors?.default
                              ? "is-invalid"
                              : ""
                              }`}
                            id="4"
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </select>
                          <span className="invalid-feedback">{err1}</span>
                          {errors.masterFields?.[index]?.errors?.default && (
                            <div className="invalid-feedback">
                              {errors.masterFields[index].errors.default}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col col-6">
                        <div className="d-flex flex-column">
                          <label
                            htmlFor="required"
                            className="addunit-form-text"
                          >
                            Is Required <span className="text-danger"> *</span>
                          </label>
                          <select
                            name="required"
                            value={field.required}
                            onChange={(e) =>
                              handleChange(e, index, "masterFieldData")
                            }
                            className={`form-select select-unit textarea ${errors.masterFields?.[index]?.errors?.required
                              ? "is-invalid"
                              : ""
                              }`}
                            id="4"
                            disabled={field.default === "true" || field.is_unique === "true"}
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </select>
                          {errors.masterFields?.[index]?.errors?.required && (
                            <div className="invalid-feedback">
                              {errors.masterFields[index].errors.required}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row mb-4">
                      <div className="col col-6">
                        <div className="d-flex flex-column">
                          <label
                            htmlFor="default"
                            className="addunit-form-text"
                          >
                            Is Unique <span className="text-danger"> *</span>
                          </label>
                          <select
                            name="is_unique"
                            value={field.is_unique}
                            onChange={(e) =>
                              handleChange(e, index, "masterFieldData")
                            }
                            className={`form-select select-unit textarea ${errors.masterFields?.[index]?.errors?.is_unique
                              ? "is-invalid"
                              : ""
                              }`}
                            id="4" disabled={field.default === "true"}
                          >
                            <option value="false">No</option>
                            <option value="true">Yes</option>
                          </select>
                          <span className="invalid-feedback">{err1}</span>
                          {errors.masterFields?.[index]?.errors?.default && (
                            <div className="invalid-feedback">
                              {errors.masterFields[index].errors.default}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col col-6">
                        <div className="d-flex flex-column">
                          <label htmlFor="tooltip" className="addunit-form-text">
                            Tooltip <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="tooltip"
                            placeholder="Set the tooltip"
                            id={`tooltip${index}`}
                            value={field.tooltip}
                            onChange={(e) =>
                              handleChange(e, index, "masterFieldData")
                            }
                            className={`form-control ${errors[`masterFieldData[${index}].tooltip`]
                              ? "is-invalid"
                              : ""
                              }`}
                          />
                          {errors[`masterFieldData[${index}].tooltip`] && (
                            <div className="invalid-feedback">
                              {errors[`masterFieldData[${index}].tooltip`]}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>


                    <hr />
                  </div>
                ))}
                <button
                  type="button"
                  id="openPopup"
                  className="btn-bg mb-4"
                  onClick={handleAddField}
                >
                  <span className="plus-icon">
                    <img src={plus1} alt="Plus Icon" />
                  </span>{" "}
                  Add Field
                </button>
              </div>
              <div className="addunit-card-footer justify-content-between">
                <button
                  type="button"
                  className="discard-btn"
                  onClick={() => {
                    setFormData({
                      masterData: {
                        master_name: "",
                        slug: null,
                        display_name_singular: "",
                        display_name_plural: "",
                        icon: null,
                        model_name: "",
                        parameter_type_id: "",
                        order: "",
                      },
                      masterFieldData: [
                        {
                          field_name: "",
                          field_type: "",
                          display_name: "",
                          required: "",
                          default: "",
                          order: "",
                          browse: false,
                          read: false,
                          edit: false,
                          add: false,
                          delete: false,
                          order: 0,
                          validation: "",
                        },
                      ],
                    });
                    setErrors({});
                    handleClose();
                  }}
                >
                  Close
                </button>
                <button
                  type="submit"
                  id="openPopup"
                  className="update-btn"
                  disabled={!isFieldNameValid} // Disable button based on field name validity
                  style={{
                    backgroundColor: !isFieldNameValid ? "lightgray" : "",
                  }} // Change color when disabled
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddModal;
